import React from "react";
import { Link } from "react-router-dom";
import styles from "../styles/Header.module.css";

const projects = [
  {
    id: "getthere",
    index: "01",
    title: "GetThere — Tour Aggregator Platform",
    description:
      "Production travel platform serving real operators and travelers. Aggregates tour packages from multiple operators, handles per-distributor pricing rules, Paystack payments, and a white-label widget API for partner embeds.",
    tech: ["React", "Node.js", "MongoDB", "Paystack", "Cloudinary"],
    live: "https://getthere.sabrecwa.com/",
  },
  {
    id: "travelbook-lite",
    index: "02",
    title: "TravelBook Lite",
    description:
      "B2B platform for sub-travel agents. Flight search with markup pricing, invoice generation, virtual wallets funded via Paystack and bank transfer, and a full admin layer for the parent agency to confirm transfers and authorize wallet top-ups.",
    tech: ["React", "Node.js", "PostgreSQL", "Paystack"],
    github: "https://github.com/Mercy-Iyanu/travelbook-lite",
  },
  {
    id: "travel-search-ui",
    index: "03",
    title: "travel-search-ui",
    description:
      "Open-source npm package — a composable Next.js/React travel search filter layout. Drop-in filter panel, date range picker, and results grid wired to any flight or tour API. Zero config for common patterns, fully overridable.",
    tech: ["TypeScript", "React", "Next.js", "npm"],
    github: "https://github.com/Mercy-Iyanu/travel-search-ui",
    npm: "https://www.npmjs.com/package/travel-search-ui",
  },
];

const WorkPage = () => (
  <div className={styles.page}>
    <section className={styles.work}>
      <div className={styles.sectionWrap}>
        <h2 className={styles.sectionHeading}>Selected Work</h2>
        <div className={styles.projectList}>
          {projects.map((p) => (
            <div key={p.id} className={styles.projectRow}>
              <span className={styles.projectNum}>{p.index}</span>
              <div className={styles.projectMain}>
                <div className={styles.projectHeader}>
                  <h3 className={styles.projectTitle}>{p.title}</h3>
                  <div className={styles.projectLinks}>
                    <Link to={`/project/${p.id}`} className={styles.projLink}>
                      Case Study ↗
                    </Link>
                    {p.live && (
                      <a
                        href={p.live}
                        target="_blank"
                        rel="noreferrer"
                        className={styles.projLink}
                      >
                        Live ↗
                      </a>
                    )}
                    {p.github && (
                      <a
                        href={p.github}
                        target="_blank"
                        rel="noreferrer"
                        className={styles.projLink}
                      >
                        Code ↗
                      </a>
                    )}
                    {p.npm && (
                      <a
                        href={p.npm}
                        target="_blank"
                        rel="noreferrer"
                        className={styles.projLink}
                      >
                        npm ↗
                      </a>
                    )}
                  </div>
                </div>
                <p className={styles.projectDesc}>{p.description}</p>
                <div className={styles.projectTech}>
                  {p.tech.map((t) => (
                    <span key={t} className={styles.techTag}>
                      {t}
                    </span>
                  ))}
                </div>
                {p.note && <p className={styles.projectNote}>{p.note}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default WorkPage;
